module.exports = __webpack_public_path__ + "img/check-done-02.e082f001.svg";